/* FB PRODUCT — variantvalg, pris, knap-status, antal og URL-opdatering. */
(function () {
  'use strict';

  if (customElements.get('fb-variants')) return;

  function money(cents) {
    var fmt =
      (window.Shopify && window.Shopify.money_format) || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    // Dansk format som standard: 1.234,56
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var pretty = whole + ',' + parts[1];
    if (fmt.indexOf('{{amount_no_decimals}}') > -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole);
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, pretty);
  }

  class FbVariants extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-fb-variant-data]');
      if (!dataEl) return;

      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      this.root = this.closest('.fb-pdp');
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.productUrl = this.dataset.productUrl;

      this.addEventListener('change', this.onChange.bind(this));
      this.setupQuantity();
      this.setupMediaSync();
      this.setupStickyAtc();
    }

    selectedOptions() {
      var checked = this.querySelectorAll('input[type="radio"]:checked');
      return Array.prototype.map.call(checked, function (i) {
        return i.value;
      });
    }

    onChange(e) {
      if (!e.target.matches('input[type="radio"]')) return;

      var opts = this.selectedOptions();
      var match = this.variants.find(function (v) {
        return opts.every(function (val, i) {
          return v.options[i] === val;
        });
      });

      this.renderOptionLabels(opts);

      if (!match) {
        this.setUnavailable();
        return;
      }

      this.current = match;
      this.renderPrice(match);
      this.renderButton(match);
      this.renderVariantId(match);
      this.renderUrl(match);
      this.renderStickyAtc(match);
      this.scrollToMedia(match);
    }

    renderOptionLabels(opts) {
      var labels = this.querySelectorAll('[data-fb-option-value]');
      Array.prototype.forEach.call(labels, function (el) {
        var idx = parseInt(el.dataset.fbOptionValue, 10);
        if (opts[idx]) el.textContent = opts[idx];
      });
    }

    renderPrice(v) {
      if (!this.root) return;
      var el = this.root.querySelector('[data-fb-price]');
      if (!el) return;

      /* Foerpris + neutralt "Spar X"-badge. Label kommer fra Liquid, saa det
         foelger sprogversionen. Bevidst ingen accentroed nypris. */
      var label = el.dataset.saveLabel || 'Save';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        el.innerHTML =
          '<span class="fb-pdp__now">' +
          money(v.price) +
          '</span><s class="fb-pdp__was">' +
          money(v.compare_at_price) +
          '</s><span class="fb-pdp__save">' +
          label +
          ' ' +
          money(v.compare_at_price - v.price) +
          '</span>';
      } else {
        el.innerHTML = '<span>' + money(v.price) + '</span>';
      }

      this.renderSave(v);
    }

    /* Besparelses-badge: beloeb og procent for den valgte variant. */
    renderSave(v) {
      if (!this.root) return;
      var box = this.root.querySelector('[data-fb-save]');
      if (!box) return;

      /* Sale/foerpris slaaet fra 17-08-2026 efter oenske fra Doubles. Save-badget er slaaet fra.
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var diff = v.compare_at_price - v.price;
        var pct = Math.round((diff * 100) / v.compare_at_price);
        box.innerHTML =
          '<span class="fb-pdp__save">Save ' +
          money(diff) +
          ' \u00b7 ' +
          pct +
          '%</span>';
        box.hidden = false;
      } else {
        box.innerHTML = '';
        box.hidden = true;
      }
      */
      box.innerHTML = '';
      box.hidden = true;
    }

    renderButton(v) {
      if (!this.root) return;
      var btn = this.root.querySelector('[data-fb-add]');
      var txt = this.root.querySelector('[data-fb-add-text]');
      if (!btn) return;

      btn.disabled = !v.available;
      if (txt) {
        txt.textContent = v.available
          ? btn.dataset.labelDefault || txt.dataset.label || txt.textContent.trim() || 'Add to cart'
          : 'Sold out';
      }
      if (v.available && txt && txt.textContent === 'Sold out') {
        txt.textContent = 'Add to cart';
      }
    }

    setUnavailable() {
      if (!this.root) return;
      var btn = this.root.querySelector('[data-fb-add]');
      var txt = this.root.querySelector('[data-fb-add-text]');
      if (btn) btn.disabled = true;
      if (txt) txt.textContent = 'Unavailable';
    }

    renderVariantId(v) {
      if (!this.root) return;
      var input = this.root.querySelector('[data-fb-variant-id]');
      if (input) input.value = v.id;
    }

    renderUrl(v) {
      if (!this.updateUrl || !this.productUrl) return;
      window.history.replaceState({}, '', this.productUrl + '?variant=' + v.id);
    }

    /* Pinnet ramme: sporet traekkes op i takt med scrollen, saa billedet
       glider ud i toppen og det naeste glider ind i midten. */
    setupMediaSync() {
      this.stack = this.root
        ? this.root.querySelector('[data-fb-media-stack]')
        : null;
      if (!this.stack) return;

      this.runway = this.root.querySelector('[data-fb-media-runway]');
      this.frame = this.root.querySelector('[data-fb-media-frame]');
      this.items = Array.prototype.slice.call(
        this.stack.querySelectorAll('.fb-pdp__media-item')
      );
      this.dots = Array.prototype.slice.call(
        this.root.querySelectorAll('.fb-pdp__dot')
      );
      if (!this.runway || !this.frame || this.items.length < 2) return;

      this.activeIndex = -1;
      this.mq = window.matchMedia('(min-width: 990px)');
      this.ticking = false;

      var self = this;
      this.onScroll = function () {
        if (self.ticking) return;
        self.ticking = true;
        window.requestAnimationFrame(function () {
          self.syncFrame();
          self.ticking = false;
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.stack.addEventListener('scroll', this.onScroll, { passive: true });

      this.syncFrame();
    }

    syncFrame() {
      if (!this.items || this.items.length < 2) return;

      var n = this.items.length;
      var idx;

      if (this.mq && this.mq.matches) {
        // Hvor langt er runwayen scrollet forbi den pinnede ramme?
        var rect = this.runway.getBoundingClientRect();
        var frameH = this.frame.offsetHeight || 1;
        var travel = Math.max(1, rect.height - frameH);
        var p = Math.min(Math.max(-rect.top / travel, 0), 1);

        // Traek sporet: 0 = foerste billede, 1 = sidste
        var shift = p * (n - 1) * 100;
        this.stack.style.transform = 'translate3d(0,' + -shift + '%,0)';

        idx = Math.round(p * (n - 1));
      } else {
        this.stack.style.transform = '';
        var w = this.stack.clientWidth || 1;
        idx = Math.round(this.stack.scrollLeft / w);
      }

      idx = Math.min(Math.max(idx, 0), n - 1);
      if (idx === this.activeIndex) return;
      this.activeIndex = idx;

      this.items.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
      });
      this.dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    scrollToMedia(v) {
      if (!this.stack || !v.featured_media) return;
      var target = this.stack.querySelector(
        '[data-media-id="' + v.featured_media.id + '"]'
      );
      if (!target || !this.items) return;
      var idx = this.items.indexOf(target);
      if (idx < 0) return;

      if (this.mq && this.mq.matches) {
        // Rul siden derhen hvor sporet viser det billede
        var rect = this.runway.getBoundingClientRect();
        var frameH = this.frame.offsetHeight || 1;
        var travel = Math.max(1, rect.height - frameH);
        var runwayTop = rect.top + window.scrollY;
        var want = runwayTop + (idx / (this.items.length - 1)) * travel;
        window.scrollTo({ top: want, behavior: 'smooth' });
      } else {
        this.stack.scrollTo({
          left: target.offsetLeft - this.stack.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    /* Sticky koeb-knap: vises naar hovedknappen er scrollet ud af syne */
    setupStickyAtc() {
      if (!this.root) return;
      this.stickyBar = this.root.querySelector('[data-fb-sticky-atc]');
      var mainBtn = this.root.querySelector('[data-fb-add]');
      if (!this.stickyBar || !mainBtn) return;

      var bar = this.stickyBar;
      bar.removeAttribute('hidden');

      if (!('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // Vis baren naar hovedknappen IKKE er synlig
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      );
      io.observe(mainBtn);
    }

    renderStickyAtc(v) {
      if (!this.stickyBar) return;

      var price = this.stickyBar.querySelector('[data-fb-sticky-price]');
      if (price) price.textContent = money(v.price);

      var btn = this.stickyBar.querySelector('[data-fb-sticky-btn]');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }

    /* Quantity plus/minus */
    setupQuantity() {
      if (!this.root) return;
      var input = this.root.querySelector('.fb-pdp__qty-control input');
      if (!input) return;

      this.root.querySelectorAll('[data-fb-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.fbQty, 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }

  customElements.define('fb-variants', FbVariants);
})();
